import { computed, ref, toRaw, watch } from 'vue'

import axios from 'axios'

const confined_spaces = ref([])
const inventory_total_confined_spaces = ref(0)
const confined_space_filters = ref({})
const inventory_filters = ref({})
const filtered_confined_spaces = ref([])
const loading = ref(false)

export default function useConfinedSpaces() {
  const listConfinedSpaces = async (order_of_service_id) => {
    axios
      .get('/api/confined_spaces/all', { params: { order_of_service_id: order_of_service_id } })
      .then(response => {
        confined_spaces.value = filtered_confined_spaces.value = response.data.data
      })
      .catch(() => {})
  }

  const saveConfinedSpaceApr = async (data) => {
    return axios.post('/api/confined_spaces/apr', data)
  }

  const listInventory = async (order_of_service_id, page, per_page, NR = 0) => {
    loading.value = true

    const filters = Object.keys(inventory_filters.value)
      .filter(key => inventory_filters.value[key])
      .map(key => ({ [key]: inventory_filters.value[key].toString() }))
      .reduce((result, current) => Object.assign(result, current), {})

     return new Promise((resolve, reject) => {
       axios
        .get('/api/confined_spaces/inventory', {
          params: Object.assign(
            {
              order_of_service_id,
              page,
              per_page,
              NR,
            },
            filters,
          ),
        })
        .then(response => {
          inventory_total_confined_spaces.value = response.data.meta.total
          confined_spaces.value = filtered_confined_spaces.value = response.data.data

          confined_spaces.value = confined_spaces.value.map(confined_space => {
            confined_space.bvs_amount = confined_space.confined_space_entries.length
            confined_space.is_rescue_point_required = confined_space.is_rescue_point_required ? 'Sim' : 'Não'
            confined_space.has_datasheet = confined_space.has_datasheet ? 'Sim' : 'Não'
            confined_space.is_datasheet_updated = confined_space.is_datasheet_updated ? 'Sim' : 'Não'
            confined_space.is_completely_suitable = confined_space.is_completely_suitable ? 'Sim' : 'Não'
          })
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
        .finally(() => (loading.value = false))
     })
  }

  const destroyConfinedSpace = async (event) => {
    axios
      .delete('/api/confined_spaces/destroy/' + event.id)
      .then(() => {
        confined_spaces.value.splice(event.index, 1)
      })
      .catch(() => {})
  }

  const updateConfinedSpaceFilters = async () => {
    let filters = toRaw(confined_space_filters.value)

    filtered_confined_spaces.value = confined_spaces.value.filter(row => {
      let confined_space = toRaw(row)
      let matches = 0

      for (let key of Object.keys(filters)) {
        if (filters[key].toString().trim() == '') {
          matches++
          continue
        }

        if (
          machine[key]
            .toString()
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(new RegExp(/[\u0300-\u036f]/, 'gi'), '')
            .includes(
              filters[key]
                .toString()
                .trim()
                .toLowerCase()
                .normalize('NFD')
                .replace(new RegExp(/[\u0300-\u036f]/, 'gi'), ''),
            )
        ) {
          matches++
        }
      }

      return matches == Object.keys(filters).length
    })
  }

  watch(confined_space_filters.value, () => {
    updateConfinedSpaceFilters()
  })

  return {
    confined_spaces: computed(() => confined_spaces.value),
    confined_space_filters,
    inventory_filters,
    filtered_confined_spaces: computed(() => filtered_confined_spaces.value),
    inventory_total_confined_spaces,
    loading,
    listConfinedSpaces,
    listInventory,
    destroyConfinedSpace,
    updateConfinedSpaceFilters,
  }
}
